// Stub page — content will be replaced when user sends screenshots.
// Same NavBar + Footer wrap, with placeholder content matching homepage style.

export default function PlaceholderPage({ title, accent = "#0041E6", subtitle, ctaLabel, ctaUrl }) {
  return (
    <div className="min-h-[60vh] py-24" data-testid={`page-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="mx-auto max-w-[1200px] px-5 md:px-12 text-center">
        <h1
          className="font-display text-[60px] md:text-[110px] leading-none"
          style={{ color: accent }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="mt-8 text-[20px] md:text-[24px] text-black/75 max-w-2xl mx-auto leading-snug">
            {subtitle}
          </p>
        )}
        {ctaLabel && ctaUrl && (
          <a
            href={ctaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 inline-flex items-center justify-center bg-[#0041E6] hover:bg-[#0033B8] text-white font-medium text-[18px] rounded-full h-[52px] px-10 transition shadow-[0_8px_24px_-8px_rgba(0,65,230,0.55)]"
            data-testid="page-cta"
          >
            {ctaLabel}
          </a>
        )}
        <div className="mt-16 text-sm text-black/40 italic">
          Full page content coming soon — send the screenshot of this page from your live site to populate it exactly.
        </div>
      </div>
    </div>
  );
}
